(() => {
  const savedLinks = new Map();
  const savedHeaders = new WeakMap();
  function update() {
    const controls = document.querySelector('[data-landing-offer-controls]');
    const disableLogo = controls?.dataset.disableLogoLink === 'true';
    document.querySelectorAll('.m-header .m-logo a').forEach(link => {
      if (disableLogo) {
        if (!savedLinks.has(link)) savedLinks.set(link, { href: link.getAttribute('href'), tabindex: link.getAttribute('tabindex') });
        link.removeAttribute('href');
        link.setAttribute('tabindex', '-1');
      }
    });
    savedLinks.forEach((saved, link) => {
      if (!link.isConnected || !disableLogo) {
        if (link.isConnected) {
          for (const [name, value] of Object.entries(saved)) {
            if (value === null) link.removeAttribute(name);
            else link.setAttribute(name, value);
          }
        }
        savedLinks.delete(link);
      }
    });
    const header = document.querySelector('m-header');
    if (!header || typeof header.handleSticky !== 'function') return;
    if (!savedHeaders.has(header)) savedHeaders.set(header, header.dataset.sticky || 'none');
    const requested = controls?.dataset.headerStickyBehavior || 'theme';
    const sticky = requested === 'theme' ? savedHeaders.get(header) : requested;
    if (header.stickyHeader !== sticky) {
      header.dataset.sticky = sticky;
      header.stickyHeader = sticky;
      header.classList.remove('stuck', 'scroll-up', 'scroll-down', 'header-sticky-always');
      document.body.classList.remove('header-scroll-up', 'header-scroll-down');
      header.classList.toggle('header-sticky-always', sticky === 'always');
      header.handleSticky();
    }
  }
  update();
  customElements.whenDefined('m-header').then(update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(update));
})();
